import { render, staticRenderFns } from "./add-kunci_pembelajaran.vue?vue&type=template&id=6ab6bebd&"
import script from "./add-kunci_pembelajaran.vue?vue&type=script&lang=js&"
export * from "./add-kunci_pembelajaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports